<template>
  <div id="app">
    <daohang> </daohang>

    <router-view></router-view>
    <!-- <dibudaohang> </dibudaohang> -->
    <footer2></footer2>
  </div>
</template>

<script>
import daohang from "./components/nav.vue";
import footer2 from "./components/footer.vue";
// import dibudaohang from "./components/dibudaohang/dibudaohang";

export default {
  name: "App",
  components: {
    daohang,
    footer2
    // dibudaohang
  },
};
</script>

<style>
body {
  margin: 0;
  overflow-x: hidden;
}
</style>
